export const messages = {
  en: {
    printCommonReportTable: {
      print: 'Print',
      cancel: 'Cancel',
      componentName: 'Report Name',
      tableHeader: 'Table Header',
      footer: 'Footer Information'
    }
  },
  zh: {
    printCommonReportTable: {
      print: '打印',
      cancel: '取消',
      componentName: '报表名称',
      tableHeader: '表头',
      footer: '页脚信息'
    }
  }
}